import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Conditions from "../../components/pages/GoodsReturn/Conditions/Conditions";

const GoodsReturnPage: React.FC = () => {
  return (
    <Layout>
      <Conditions />
      <Feedback />
    </Layout>
  );
};

export default GoodsReturnPage;
